module.exports = __webpack_public_path__ + "static/img/14003017.ff4ae9f4.png";